import { listenerMiddleware } from "../../../store/middleware.js";
import socketFactory, { mapSocketFactory } from "../../../utils/socketFactory.js";
import {
  RECEIVE_RAISE_HAND,
  RECEIVE_LOWER_HAND,
  CLEAR_HANDS
} from "./raisedHandsSlice.js";
import { setCurrentRoom } from "../../Map/store/MapDisplaySlice";

let initialized = false;

listenerMiddleware.startListening({
  predicate: () => {
    if (initialized) return false;
    initialized = true;
    return true;
  },

  effect: async (_, api) => {
    console.log("raisedHandsMiddleware INITIALIZED");

 
    const extract = (payload) => payload?.data ?? payload;

    const isFromAnotherRoom = (data, api) => {
      const currentRoomId = api.getState().MapDisplay.currentRoom?.room_id;

      if (!data.roomId) return false;

      return data.roomId !== currentRoomId;
    };

     const handleAutoLowerHand = () => {
      const state = api.getState();
      const localAvatar = state.auth?.localAvatar;
      const currentRoom = state.MapDisplay?.currentRoom;

      if (!localAvatar?.id || !currentRoom?.room_id) return;

      console.log("AUTO LOWER HAND on refresh/close (middleware)");

      socketFactory.socket.emit("lowerHandToRoom", {
        sender: localAvatar.id,
        senderEmail: localAvatar.email,
        roomId: currentRoom.room_id,
      });
    };

    window.addEventListener("beforeunload", handleAutoLowerHand);

    socketFactory.on("receiveRaiseHand", (payload) => {
      console.log("SOCKET EVENT receiveRaiseHand:", payload);

      const data = extract(payload);
      if (!data) return;

      if (isFromAnotherRoom(data, api)) {
        console.log("Ignored raiseHand from another room →", data.roomId);
        return;
      }

      api.dispatch(
        RECEIVE_RAISE_HAND({
          sender: data.senderId,
          senderEmail: data.senderEmail,
          senderName: data.senderName,
          time: data.time
        })
      );
    });

    socketFactory.on("receiveLowerHand", (payload) => {
      console.log("SOCKET EVENT receiveLowerHand:", payload);

      const data = extract(payload);
      if (!data) return;

      if (isFromAnotherRoom(data, api)) {
        console.log("Ignored lowerHand from another room →", data.roomId);
        return;
      }

      api.dispatch(RECEIVE_LOWER_HAND(data.senderId));
    });


  mapSocketFactory.on("receiveHandsInitialState", (payload) => {
  console.log("SOCKET EVENT receiveHandsInitialState:", payload);

  const extracted = payload.data ?? payload;

  const roomId = extracted.roomId;
  const list = extracted.list;

  const currentRoomId = api.getState().MapDisplay.currentRoom?.room_id;

  if (!currentRoomId) {
    console.log("Ignored initialState → no current room selected");
    return;
  }

  if (roomId !== currentRoomId) {
    console.log(
      "Ignored initialState from another room →",
      roomId,
      "current:",
      currentRoomId
    );
    return;
  }

  api.dispatch(CLEAR_HANDS());

  if (!Array.isArray(list)) return;

  list.forEach((h) => {
    api.dispatch(
      RECEIVE_RAISE_HAND({
        sender: h.sender,
        senderEmail: h.senderEmail,
        senderName: h.senderName,
        time: h.time,
      })
    );
  });
});



  },
});

listenerMiddleware.startListening({
  actionCreator: setCurrentRoom,
  effect: async (action, api) => {
    const prevState = api.getOriginalState();
    const nextState = api.getState();           

    const prevRoom = prevState.MapDisplay.currentRoom;
    const nextRoom = nextState.MapDisplay.currentRoom;

    const localAvatar =
      nextState.auth?.localAvatar || prevState.auth?.localAvatar;

    if (prevRoom?.room_id && localAvatar?.id) {
      const hadHandUp = prevState.raisedHands.list.some(
        (h) => h.sender === localAvatar.id
      );

      if (hadHandUp) {
        console.log(
          "🧹 AUTO LOWER HAND because user leaves room",
          prevRoom.room_id
        );

        socketFactory.socket.emit("lowerHandToRoom", {
          sender: localAvatar.id,
          senderEmail: localAvatar.email,
          roomId: prevRoom.room_id,
        });
      }
    }

    if (nextRoom?.room_id && localAvatar?.id) {
      console.log("🟦 FRONT → send joinRoom (middleware)", {
        roomId: nextRoom.room_id,
        user: localAvatar.display_name || localAvatar.name,
      });

      socketFactory.socket.emit("joinRoom", {
        roomId: nextRoom.room_id,
      });
    }

    console.log("🧹 CLEAR HANDS → user changed room", action.payload);
    api.dispatch(CLEAR_HANDS());
  },
});
